import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const LOGO = 'https://customer-assets.emergentagent.com/job_a638eaf5-87e7-49db-ab47-92900872b6eb/artifacts/84ltpppp_CultureCracker_Registered.png';

const t = {
  de: { claim: 'Ein Produkt von The Flow Company.\nStrategische Kultur-Interventionen für Führungsteams.', nav: 'NAVIGATION', contact: 'KONTAKT', legal: 'RECHTLICHES', impressum: 'Impressum', datenschutz: 'Datenschutz', moment: 'Der Moment', mechanism: 'Mechanismus', box: 'Die Box', options: 'Optionen' },
  en: { claim: 'A product by The Flow Company.\nStrategic culture interventions for leadership teams.', nav: 'NAVIGATION', contact: 'CONTACT', legal: 'LEGAL', impressum: 'Legal Notice', datenschutz: 'Privacy Policy', moment: 'The Moment', mechanism: 'Mechanism', box: 'The Box', options: 'Options' },
};

const FooterNew = () => {
  const { language } = useLanguage();
  const l = t[language];
  const go = (id) => { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); else window.location.href = '/#' + id; };

  return (
    <footer className="bg-[var(--bg-primary)] border-t border-[var(--hairline)] py-16 sm:py-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="sm:col-span-2 lg:col-span-1">
            <img src={LOGO} alt="Culture Cracker®" className="h-10 mb-4" />
            <p className="body-sm leading-relaxed whitespace-pre-line">{l.claim}</p>
          </div>
          <div>
            <p className="eyebrow mb-4">{l.nav}</p>
            <div className="space-y-2">
              {[{label: l.moment, id: 'moment'}, {label: l.mechanism, id: 'mechanismus'}, {label: l.box, id: 'box'}, {label: l.options, id: 'optionen'}].map(n => (
                <button key={n.id} onClick={() => go(n.id)} className="block body-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors">{n.label}</button>
              ))}
            </div>
          </div>
          <div>
            <p className="eyebrow mb-4">{l.contact}</p>
            <a href="mailto:hello@culturecracker.io" className="block body-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors mb-2">hello@culturecracker.io</a>
            <div className="flex gap-4 mt-4">
              <a href="https://www.linkedin.com/company/culturecracker" target="_blank" rel="noopener noreferrer" className="body-sm text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors">LinkedIn</a>
              <a href="https://www.instagram.com/culturecracker.io" target="_blank" rel="noopener noreferrer" className="body-sm text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors">Instagram</a>
            </div>
          </div>
          <div>
            <p className="eyebrow mb-4">{l.legal}</p>
            <div className="space-y-2">
              <Link to="/legal" className="block body-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors">{l.impressum}</Link>
              <Link to="/privacy" className="block body-sm text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors">{l.datenschutz}</Link>
            </div>
          </div>
        </div>
        <div className="border-t border-[var(--hairline)] pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-mono text-[10px] tracking-[0.2em] text-[var(--text-muted)]">© 2026 CULTURE CRACKER® · THE FLOW COMPANY</p>
          <div className="flex gap-6">
            <Link to="/legal" className="font-mono text-[10px] tracking-[0.2em] text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors">{l.impressum.toUpperCase()}</Link>
            <Link to="/privacy" className="font-mono text-[10px] tracking-[0.2em] text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors">{l.datenschutz.toUpperCase()}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterNew;
